<template>
  <div class="bond-giveback-list-page">
    <!-- 顶部合计区 -->
    <BondGiveBackTotal />
    <div class="content-box">
      <!-- 表单搜索项 -->
      <BondGiveBackListForm @search="formSearch" @exportSubmit="exportSubmit" />
      <!-- 列表 -->
      <MJList
        :loading="loading"
        :tableData="tableData"
        :tableCells="tableCells"
        :total="total"
        :max-height="400"
        :pageNum="pageData.pageNum"
        @search="searchPage">
        <!-- 线下支付需要有凭证图片预览功能 -->
        <template #bondAmount="{ scope }">
          {{ scope.row.bondAmount | moneyFilter }}
          <el-button
            v-if="scope.row.payVoucher"
            type="text"
            icon="el-icon-picture-outline"
            @click="handlePreviewImg(scope.row.payVoucher)"></el-button>
        </template>
        <!-- 保证金状态区分线上支付与线下支付 -->
        <template #bondStatus="{ scope }">
          <span v-if="scope.row.payWay === 0">
            {{ scope.row.bondStatus | bondStatusFilter }}
          </span>
          <span v-if="scope.row.payWay === 1">
            {{ scope.row.offLineBondStatus | offLineBondStatusFilter }}
          </span>
        </template>
      </MJList>
    </div>
    <!-- 图片预览 -->
    <PreviewImg ref="previewImgRef" />
  </div>
</template>

<script>
import { axiosListUserBondReturn, axiosExportUserBondReturn } from "@/api/hy";
import BondGiveBackTotal from "./components/BondGiveBackTotal.vue";
import BondGiveBackListForm from "./components/BondGiveBackListForm.vue";
import MJList from "@/components/MJList.vue";
import PreviewImg from "@/components/PreviewImg.vue";
import Vue from "vue";
import * as types from "@/store/action-types";
import moment from "moment";
import url from "@/api/url/hy_url";
import { thousands } from "@/utils/toolset.js";
const { baseUrl } = require("@/config");

export default {
  data() {
    return {
      /** ------- 搜索项-------- */
      formData: {
        /** 商品编号 */
        goodsNum: "",
        /** 发起企业名称 */
        publisherName: "",
        /** 交易类型(1:煤炭交易，2:物流竞价） */
        bondTradeType: "",
        /** 交易方式(1:竞价采购，2:竞价销售  3：竞价物流) */
        tradeWay: "",
        /** 支付方式（0:线上支付,1:线下支付） */
        payWay: "",
        /** 保证金状态(1:支付成功、2:退还中、3:已退还、4:履约中、5:违约处置)*/
        bondStatus: "",
        /** 线下保证金状态（0:待审核,1:支付成功,2:审核拒绝,3:已退还,4:已扣除） */
        offLineBondStatus: "",
        /** 竞价状态(0:进行中，1:未中标，2:已中标 -1:未开始) */
        binddingStatus: "",
        /** 支付开始日期 */
        startTime: "",
        /** 支付结束日期 */
        endTime: "",
      },
      /** ------- 列表项 ------- */
      loading: false,
      total: 0,
      tableData: [],
      tableCells: [
        {
          prop: "goodsNum",
          label: "商品编号",
          minWidth: "140px",
          fixed: "left",
        },
        {
          prop: "goodsName",
          label: "商品名称",
          minWidth: "140px",
        },
        {
          prop: "publisherName",
          label: "发起企业名称",
          minWidth: "140px",
        },
        {
          prop: "bondTradeType",
          label: "交易类型",
          minWidth: "100px",
          format: function (data) {
            let _data = {
              1: {
                label: "煤炭交易",
              },
              2: {
                label: "物流竞价",
              },
            };
            return _data[data.bondTradeType] || {};
          },
        },
        {
          prop: "tradeWay",
          label: "交易方式",
          minWidth: "100px",
          format: function (data) {
            let _data = {
              1: {
                label: "竞价采购",
              },
              2: {
                label: "竞价销售",
              },
              3: {
                label: "物流竞价",
              },
            };
            return _data[data.tradeWay] || {};
          },
        },
        {
          prop: "payWay",
          label: "支付方式",
          minWidth: "100px",
          format: function (data) {
            let _data = {
              0: {
                label: "线上支付",
              },
              1: {
                label: "线下支付",
              },
            };
            return _data[data.payWay] || {};
          },
        },
        {
          prop: "biddingStatus",
          label: "竞价状态",
          minWidth: "100px",
          format: function (data) {
            let _data = {
              "-1": {
                label: "未开始",
              },
              0: {
                label: "进行中",
              },
              1: {
                label: "未中标",
              },
              2: {
                label: "已中标",
              },
            };
            return _data[data.biddingStatus] || {};
          },
        },
        {
          prop: "bankType",
          label: "支付账户",
          minWidth: "100px",
          format: function (data) {
            let _data = {
              0: {
                label: "中信账户",
              },
              1: {
                label: "中金账户",
              },
            };
            return _data[data.bankType] || {};
          },
        },
        {
          prop: "bondStatus",
          label: "保证金状态",
          minWidth: "100px",
        },
        {
          prop: "bondAmount",
          label: "支付金额",
          minWidth: "140px",
        },
        {
          prop: "returnBondAmount",
          label: "退款金额",
          minWidth: "140px",
          format: function (data) {
            if (!data.returnBondAmount) return "";
            return {
              label: thousands(data.returnBondAmount),
            };
          },
        },
        {
          prop: "payCreateTime",
          label: "支付时间",
          minWidth: "160px",
          format: function (data) {
            if (!data.payCreateTime) return {};
            let time = moment(data.payCreateTime).format("YYYY-MM-DD HH:mm:ss");
            return { label: time };
          },
        },
        {
          prop: "returnPayTime",
          label: "退款时间",
          minWidth: "160px",
          format: function (data) {
            if (!data.returnPayTime) return {};
            let time = moment(data.returnPayTime).format("YYYY-MM-DD HH:mm:ss");
            return { label: time };
          },
        },
      ],
      pageData: {
        pageNum: 1,
        page: 1,
        pageSize: 10,
      },
      /** ------- 图片预览 ------- */
      fileBaseUrl: baseUrl + url.getFileUrl,
    };
  },
  filters: {
    /** 线上保证金状态 */
    bondStatusFilter(status) {
      switch (status) {
        case 1:
          return "支付成功";
        case 2:
          return "退还中";
        case 3:
          return "已退还";
        case 4:
          return "履约中";
        case 5:
          return "违约处置";
      }
    },
    /** 线下保证金状态 */
    offLineBondStatusFilter(status) {
      switch (status) {
        case 0:
          return "待审核";
        case 1:
          return "支付成功";
        case 2:
          return "审核拒绝";
        case 3:
          return "已退还";
        case 4:
          return "已扣除";
      }
    },
    moneyFilter(value) {
      if (!value) return "";
      return thousands(value);
    },
  },
  components: {
    BondGiveBackTotal,
    BondGiveBackListForm,
    MJList,
    PreviewImg,
  },
  methods: {
    /** 查看图片 */
    handlePreviewImg(url) {
      this.$refs.previewImgRef.open(this.fileBaseUrl + url);
    },
    /** 导出按钮 */
    exportSubmit() {
      if (!this.tableData.length) return this.$message.error("没有可导出的数据");
      let enterpriseId = Vue.ls.get(types.enterpriseId);
      let config = {
        ...this.formData,
        ...this.pageData,
        enterpriseId,
      };
      axiosExportUserBondReturn(config).then(res => {
        var elink = document.createElement("a");
        elink.download = "保证金退还记录.xls";
        elink.style.display = "none";
        var blob = new Blob([res], { type: "application/vnd.ms-excel" });
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      });
    },
    formSearch(data) {
      this.formData = JSON.parse(JSON.stringify(data));
      this.pageData.pageNum = 1;
      this.pageData.page = 1;
      console.log("this.formData", this.formData);
      this.getList();
    },
    searchPage(data) {
      this.pageData.pageNum = 1;
      this.pageData.page = 1;
      this.pageData = JSON.parse(JSON.stringify(data));
      this.getList();
    },
    getList() {
      this.loading = true;
      axiosListUserBondReturn({
        ...this.formData,
        ...this.pageData,
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          if (res.data) {
            this.tableData = res.data.list || [];
            // this.tableData.map((item, index) => {
            //   let number =
            //     Number(index + 1) + Number(this.pageData.pageSize * (this.pageData.pageNum - 1));
            //   item.index = number;
            // });
            console.log("tableData", this.tableData);
            this.total = res.data.total;
          } else {
            this.total = 0;
            this.tableData = [];
          }
        } else {
          this.$message(res.message);
          this.total = 0;
          this.tableData = [];
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.bond-giveback-list-page {
  background-color: #fff;
  width: 100%;
  height: calc(100% - 30px);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 30px;

  .content-box {
    padding: 20px;

    ::v-deep .el-button--text {
      padding: 0;
      margin: 0;
    }
  }
}
</style>
